export const ResourceLabel = {
  BrandName: "Brand Name",
  Resource: "Resource",
  ResourceNo: "Resource Number",
  Vendor: "Vendor",
  PurchaseDate: "Purchase Date",
  WarrantyEndDate: "Warranty End Date",
  Configuration: "Resource",
  EditConfiguration: "Update Resource",
  AddConfiguration: "Add Resource",
  ViewConfiguration: "View Configuration",
  AllocatedNumber: "Allocated Number",
  Amount: "Amount",
  PaymentMode: "Payment Mode",
  Vendor: "Vendor",
  Allocation: "Allocation",
  EmployeeName: "Employee Name",
  ResourceId: "Resource Id",
  Reason: "Reason",
  ResourceName: "Resource Name",
  AllocatedDate: "Allocated Date",
  SubmittedDate: "Submitted Date",
  SubmitDevice: "Submit Device",
  Device: "Device",
  AllocateResource: "Allocate Resource",
  AddAllocation: "Resource Allocation",
  ResourcesHistory: "Resources History",
  DamagedResources: "Damaged Resources",
  ResourceHolderName: "Resource Holder Name",
  HolderName: "Holder Name",
  IntegrityDate: "Integrity Date",
  DamageDate: "Damage Date",
  AddDamagedResources: "Add Damaged Resources",
  EditDamagedResources: "Edit Damaged Resources",
  PCModalName: "Laptop/PC Modal Name",
  PCSerialNo: "Laptop/PC Serial Number",
  Processor: "Processor",
  StorageType: "Storage Type",
  OsVersion: "OS Version",
  WarrantyStartDate: "Warranty Start Date",
  Ram: "Ram",
  OsType: "OS Type",
  GraphicCard: "Graphics Card",
  LaptopDetail: "Laptop Details",
  ManageDate: "Manage Date",
  SubmitDevice: "Submit Device",
  AddDamagedResources: "Add Damaged Resources",
  AllocatedNumberFormat: "Allocated Number must be in SI-01-24 format.",
  EndDateValidation: "End date must be after start date.",
  GeneralInformation: "General Information",
  ConfigurationDetail: "Configuration Details",
  Warranty: "Warranty",
};

export const Resources = {
  Laptop: "Laptop",
  Mouse: "Mouse",
};

export const ResourceStatus = {
  Available: "Available",
  Return: "Return",
  Success: "Success",
  Allocation: "Allocation",
  Damage: "Damage",
  Repair: "Repair",
  OnProcess: "On Process",
  Fail: "Fail",
};